import { v4 as uuid } from 'uuid';
import * as S from '../../../pages/OrdersFigurant/AssistantDirector/styles';

interface IInfo {
  label: string | JSX.Element;
  value: number | string | undefined | JSX.Element;
  color?: string;
  height?: string;
  width?: string;
  margin?: string;
  maxWidth?: string;
}

export const InfoBlock = ({ items, $listOrder }: { items: IInfo[]; $listOrder?: boolean }) => (
  <>
    {items.map(({ color, width, height, label, value, margin, maxWidth }) => {
      const isElement = (content: any) => !!content?.$$typeof;

      return (
        <S.Row key={uuid()} $color={color} $height={height} $width={width} $margin={margin} $maxWidth={maxWidth}>
          {isElement(label) ? (
            label
          ) : (
            <S.LeftColumn $isBold={typeof label === 'string' && label.includes('Item')} $listOrder={$listOrder}>
              {label}
            </S.LeftColumn>
          )}
          {isElement(value) ? (
            value
          ) : (
            <S.RightColumn $isBold={!!color} $listOrder={$listOrder}>
              {value}
            </S.RightColumn>
          )}
        </S.Row>
      );
    })}
  </>
);
